module.exports = __webpack_public_path__ + "img/135a371.jpg";